export default {
  path: 'deliveryPrivatePersonnelDetail',
  component: () => import(/* webpackChunkName: "individual-view" */ '@/pages/audit/privatePersonnelList/detail'),
  meta: {
    title: '详情'
  }
}
